import type { HomeStructureDefenseState } from "@/home/home-structure-types";
import { normalizeDefenseState } from "@/home/home-structure-defense-logic";

const PREFIX = "mind-survival/home-defense/v1";

function key(userId: string): string {
  return `${PREFIX}:${userId}`;
}

export function loadHomeStructureDefenseLocal(userId: string): HomeStructureDefenseState {
  try {
    const raw = localStorage.getItem(key(userId));
    if (!raw) return normalizeDefenseState(null);
    return normalizeDefenseState(JSON.parse(raw));
  } catch {
    return normalizeDefenseState(null);
  }
}

export function saveHomeStructureDefenseLocal(
  userId: string,
  state: HomeStructureDefenseState,
): void {
  try {
    localStorage.setItem(key(userId), JSON.stringify(normalizeDefenseState(state)));
  } catch {
    /* quota */
  }
}
